import MiddleBlock from "../../components/MiddleBlock/MiddleBlock";
import SectionHeader from "../../components/SectionHeader/SectionHeader";
import ContactContainer from "./components/WydarzeniaContainer/ContactContainer";
import "./Contact.css";

export default function Contact() {
    return (
        <div className="contact-page">
            <SectionHeader>Kontakt</SectionHeader>
            <MiddleBlock>
                <ContactContainer />
            </MiddleBlock>
        </div>
    );
}
